module.exports = __webpack_public_path__ + "img/cross.7ad2a2b4.svg";